import { Router } from '@angular/router';
import { DataLayerService } from '../../../services/utils/data-layer.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../abstraction/auth.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { LoadingService } from '../../../services/utils/loading.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  showOptions: boolean;
  showMenuMobile = false;
  private wasInside = false;

  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.showOptions = false;
    }
    this.wasInside = false;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(
    public authService: AuthService,
    private apiService: ApiService,
    public data: DataLayerService,
    private router: Router,
    private loadingS: LoadingService,
  ) {}

  ngOnInit(): void {
    this.showOptions = false;
  }

  showUserName() {
    if (!this.authService.loggedUser.name) {
      return this.authService.loggedUser.email.substr(
        0,
        this.authService.loggedUser.email.indexOf('@'),
      );
    }
    if (this.authService.loggedUser.name.length > 21) {
      return this.authService.loggedUser.name.slice(0, 21) + '..';
    } else {
      return this.authService.loggedUser.name;
    }
  }

  showOptionsClick() {
    if (this.authService.loggedUser) {
      this.showOptions = !this.showOptions;
    }
  }

  logout() {
    this.authService.logout();
  }
}
